import { useState, useCallback } from 'react';

const useAssociativeArray = (defaults = {}) => {
  const [items, setItems] = useState(defaults);
  const addItem = useCallback((key, val) => {
    setItems(i => ({
      ...i,
      [key]: val,
    }));
  }, []);

  return [items, addItem, setItems];
};

export default useAssociativeArray;
